import user from '../store/user';

export default [
  {
    path: '/partners',
    name: 'partners',
    redirect: user && user.role === 'event_organizer' ? '/partners/registration' : '/partners/events/events',

    meta: {
      layout: 'partners',
      title: 'Кабинет',
      auth: true,
    },
  },
  {
    path: '/partners/events',
    name: 'mainEvents',
    redirect: '/partners/events/events',

    meta: {
      layout: 'partners',
      title: 'Кабинет',
      auth: true,
    },
  },
  {
    name: 'events',
    path: '/partners/events/events',
    component: () => import('../views/partners/events/index'),
    meta: {
      auth: true,
      title: 'Кабинет',
      layout: 'partners',
    },
  },
  {
    name: 'registration',
    path: '/partners/registration',
    component: () => import('../views/partners/current-registration/registration-home'),
    props: true,
    meta: {
      auth: true,
      title: 'Текущая регистрация',
      layout: 'partners',
    },
  },
  {
    name: 'info',
    path: '/partners/registartion/:team',
    component: () => import('../views/partners/current-registration/registration-layout/info'),
    props: true,
    meta: {
      auth: true,
      title: 'Информация о команде',
      layout: 'partners',
    },
  },
  {
    name: 'gameQuestion',
    path: '/partners/events/events/game/:gameId',
    component: () => import('../views/partners/events/game/game-mobile'),
    props: true,
    meta: {
      auth: true,
      title: 'Замена вопроса',
    },
  },
  {
    name: 'data-base',
    path: '/partners/data-base',
    component: () => import('../views/partners/data-base/data-base-page'),
    meta: {
      auth: true,
      title: 'База данных',
      layout: 'partners',
    },
  },
  {
    name: 'news',
    path: '/partners/news',
    component: () => import('../views/partners/news/news'),
    meta: {
      auth: true,
      title: 'Что нового?',
      layout: 'partners',
    },
  },
  {
    name: 'data-base-mobile',
    path: '/partners/data-base-mobile',
    component: () => import('../views/partners/data-base/data-base-mobile'),
    meta: {
      auth: true,
      title: 'База данных',
      layout: 'partners',
    },
  },
  {
    name: 'new-team-mobile',
    path: '/partners/new-team/:eventId',
    component: () => import('../views/partners/current-registration/registration-layout/new-registration-mobile'),
    props: true,
    meta: {
      auth: true,
      title: 'Добавление команды',
      layout: 'partners',
    },
  },
  {
    name: 'places',
    path: '/partners/events/places',
    component: () => import('../views/partners/places/index'),
    meta: {
      auth: true,
      layout: 'partners',
    },
  },
  {
    name: 'season',
    path: '/partners/events/season',
    component: () => import('../views/partners/season/index'),
    props: true,
    meta: {
      auth: true,
      layout: 'partners',
    },
  },
  {
    path: '/partners/:eventUuid/draft',
    name: 'partners.events.draft',
    component:
        () => ({
          // The component to load (should be a Promise)
          component: import(/* webpackChunkName: "partners" */ '../views/partners/partners-cabinet.vue'),
          // A component to use while the async component is loading
          // loading: LoadingComponent,
          // A component to use if the load fails
          // error: ErrorComponent,
          // Delay before showing the loading component. Default: 200ms.
          delay: 200,
          // The error component will be displayed if a timeout is
          // provided and exceeded. Default: Infinity.
          timeout: 3000,
        }),
    meta: {
      layout: 'partners',
      title: 'Черновик',
      auth: true,
    },
  },
  {
    path: '/partners/:uuid/:draft_uuid/edit',
    name: 'partners.events.edit',
    component:
        () => ({
          // The component to load (should be a Promise)
          component: import(/* webpackChunkName: "partners" */ '../views/partners/events/calendar/editRecord.vue'),
          // A component to use while the async component is loading
          // loading: LoadingComponent,
          // A component to use if the load fails
          // error: ErrorComponent,
          // Delay before showing the loading component. Default: 200ms.
          delay: 200,
          // The error component will be displayed if a timeout is
          // provided and exceeded. Default: Infinity.
          timeout: 3000,
        }),
    meta: {
      layout: 'partners',
      title: 'Редактирование',
      auth: true,
    },
  },
];
